import { AffectUser } from '@/types/affectUser';
import { Organization } from '@/types/organization';
import { PersonMinimal } from '@/types/person';

export enum ReleaseOfInformationStatus {
  ACTIVE = 'active',
  PENDING = 'pending',
  EXPIRED = 'expired',
  REVOKED = 'revoked'
}

export interface ReleaseOfInformation {
  id: string;
  signed_at: string | null;
  expired_at: string | null;
  revoked_at: string | null;
  revoked_by: AffectUser | null;
  concerning: PersonMinimal | null;
  recipient: Organization | PersonMinimal | null;
  actor: AffectUser | null;
  form_answer_group_id: string | null;
  form_answer_group_healthie_id: number | null;
  consent: string[];
  created_at: string;
  updated_at: string;
  requested_form_completion_signed_at: string | null;
  service_start_at: string | null;
  service_end_at: string | null;
}

export enum ReleaseOfInformationRecipientType {
  ORGANIZATION = 'ORGANIZATION',
  PERSON = 'PERSON'
}

export interface CreateROIPayload {
  person_id: string;
  recipient_type: ReleaseOfInformationRecipientType;
  object_id: string;
}
